import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/GeistMonoVF.woff\",\"weight\":\"400 500 600\"}],\"variableName\":\"geistMono\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ConsoleWarning"] */ "/vercel/path0/src/app/components/ConsoleWarning/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/components/DevelopmentBanner/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
